import DigitalRetailOverlayCTA from './DigitalRetailOverlayCTA';

export default DigitalRetailOverlayCTA;
